module.exports = __webpack_public_path__ + "img/50_jbt8011_1-1999.prt.7767a745.jpg";